// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"SearchFilter_searchBox__1YvXO"};